import { Injectable } from '@angular/core';
import { EntityState, EntityStore, persistState, StoreConfig } from '@datorama/akita';
import { ActivityGroup } from '@app/models';
import * as localForage from 'localforage';
import { Bind } from 'lodash-decorators/bind';

const notificationStore = localForage.createInstance({
  name: 'patientLynk',
  storeName: 'notification_store'
});
persistState({ include: ['notification'], storage: notificationStore });

export interface NotificationState extends EntityState<ActivityGroup> {
  user?: string;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'notification', resettable: true })
export class NotificationStore extends EntityStore<NotificationState> {

  constructor() {
    super();
  }

  @Bind()
  akitaPreUpdate(prevState: Readonly<NotificationState>, nextState: Readonly<NotificationState>): NotificationState {
    if (prevState.user !== nextState.user) {
      this.reset();
      return { ...this.getValue(), user: nextState.user };
    }

    return super.akitaPreUpdate(prevState, nextState);
  }
}
